import React, { useEffect, useState } from 'react'
import MenuInput from './MenuInput';
import api from '../../apis/selectree_api';

function cleanInput(str) {
   var cleanString = "";
   if(str !== null && str !== undefined) {
      cleanString = str.replace(/<\/?[^>]+(>|$)/g, "");
   }

   return cleanString;
}

const formatOptionLabel = ({ value, label, common, accepted_common, name_concat, match}) => (
   <div>
  <div style={{ display: "flex" }}>
    <div><em>{label}</em></div>
    <div style={{ marginLeft: "10px"}}>
      <small>{accepted_common}</small>
    </div>
  </div>
      <small>
    {common !== accepted_common && match === "com"?<div>AKA: <small>{common}</small></div>: ""}
    {label !== name_concat && match === "sci"?<div>Synonym for: <em>{name_concat}</em></div>: ""}
      </small>
   </div>
);

function TreeSelect(props) {
   const {options, defaultTree, ...inputProps} = props;
   const [treeOptions, setTreeOptions] = useState([])
   const [searchTerm, updateSearchTerm] = useState("")
   const MIN_INPUT_LENGTH = 3;

   useEffect(() => {
     getTreeOptions();
   },[])

   async function getTreeOptions() {
      const res = await api.get("tree/search-by-name?searchString=&region=all");
      const trees = res.data;

      for(let t of trees) {
			t.value = t.tree_id;
			t.label = t.accepted_scientific;
      } 
      setTreeOptions(trees);
   }

   const filterSuggestions = (trees, searchTerm) => {
      try {
         let filteredResults = [];
         let tree_seen = new Set();

         if (searchTerm.length > 2) {
            let term = searchTerm.toLowerCase()
            let termArray = term.split(" ");
            let suggestions = trees || []

            //First, get a list of names that actually match the search term.
            suggestions.forEach((s) => {
               let cleanScientificName = "";
               let cleanCommonName = "";
               let cleanFamilyName = "";
               let cleanGenericCommon = "";
               //Clean up the possible names to search.
               s.match = ""
               if (s.name_concat) {
                  cleanScientificName = s.name_concat;
                  cleanScientificName = cleanScientificName.replace('&times ', '');
                  cleanScientificName = cleanScientificName.toLowerCase();
               }
               if (s.common) {
                  cleanCommonName = s.common.toLowerCase();
               }
               if (s.family) {
                  cleanFamilyName = s.family.toLowerCase();
               }
               if (s.generic_common) {
                  cleanGenericCommon = s.generic_common;
                  cleanGenericCommon = cleanGenericCommon.replace('&times ', '');
                  cleanGenericCommon = cleanGenericCommon.toLowerCase();
               }

               //TODO come up with better way of matching this the one use on
               //search bar minus synonym filtering but its a bit finicky
               const match = (r, str) => str.indexOf(term) >= 0 //|| str.split(" ").indexOf(r) >= 0;
               const scientificNameMatch = termArray.some(r => match(r, cleanScientificName));
               const commonNameMatch = termArray.some(r => match(r, cleanCommonName));
               const familyNameMatch = termArray.some(r => match(r, cleanFamilyName));
               const genericCommonMatch = termArray.some(r => match(r, cleanGenericCommon));

               //If the search term matches any of the names, push it into filteredResults[]
               if (scientificNameMatch || commonNameMatch || familyNameMatch || genericCommonMatch) {

                  if(scientificNameMatch)
                     s.match = "sci"

                  else if (commonNameMatch)
                     s.match = "com"

                  filteredResults.push(s);
               }

            });

            filteredResults.sort((a, b) => {
			   const namesAgreeA = a.accepted_scientific == a.name_concat? 0: 1;
			   const namesAgreeB = b.accepted_scientific == b.name_concat? 0: 1;

               if(namesAgreeA === namesAgreeB) {
				  const commonAgreeA = a.accepted_common == a.common? 0: 1;
				  const commonAgreeB = b.accepted_common == b.common? 0: 1;
                  return commonAgreeB - commonAgreeA
               }
               return namesAgreeA - namesAgreeB;
            })

            const distinctFilteredResults = []

            for(let t of filteredResults) {
               if(!tree_seen.has(t.value)) {
                  tree_seen.add(t.value)
                  distinctFilteredResults.push(t)
               }
            }
            
            //only grab first 100 searches for performance
            return distinctFilteredResults.slice(0,100);
         }

      } catch (err) {
         console.log(`components.SearchByNameSuggestionBox.filterSuggestions: ${err}`);
         return;
      }

   }

   const filterOption = (candidate, input) => {
      return (
         // Min input length
         input.length >= MIN_INPUT_LENGTH
            // Use Select's default filtering for string matching by creating filter
            //createFilter({})(candidate, input)
      );
   };

   return (
      <MenuInput
         classNamePrefix='TreeMenu'
         {...inputProps}
         value={
         defaultTree? treeOptions.find(opt => {
            if(opt.value == defaultTree.value && opt.label === defaultTree.label) {
				return opt;
			}

			if(opt.value  == defaultTree.value) {
				return opt;
			}
         }): undefined}
         options={filterSuggestions(treeOptions, searchTerm)}
         filterOption={filterOption}
         formatOptionLabel={formatOptionLabel}
         onInputChange={(input) => updateSearchTerm(input)}
         />)
}

export default TreeSelect
